import { mergeQueryKeys } from '@lukemorales/query-key-factory'

import { cart } from './cart.query'
import { categories } from './categories.query'
import { checkout } from './checkout.query'
import { orders } from './orders.query'
import { productTemplate } from './product-template.query'
import { regions } from './regions.query'
import { search } from './search.query'

export const queries = mergeQueryKeys(
    categories,
    productTemplate,
    search,
    cart,
    checkout,
    regions,
    orders,
)
